import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import { useNavigation } from '@react-navigation/core';
import React from 'react';
import styled from 'styled-components/native';
import BackIcon from '@/assets/icon/ic_v2_arrow_back.svg';
import BookmarkIcon from '@/assets/icon/ic_v2_bookmark.svg';
import BookmarkOnIcon from '@/assets/icon/ic_v2_bookmark_on.svg';
import ShareIcon from '@/assets/icon/ic_v2_share.svg';
import { SccPressable } from '@/components/SccPressable';
import { color } from '@/constant/color';
import { font } from '@/constant/font';
const ICON_COLOR = '#16181C';
export default function V2AppBar({ isFavorite, onToggleFavorite, onShare, placeName, showTitle = false, onBack, }) {
    const navigation = useNavigation();
    return (_jsxs(AppBarContainer, { children: [_jsx(SccPressable, { elementName: "place_detail_v2_back_button", hitSlop: 10, onPress: onBack !== null && onBack !== void 0 ? onBack : (() => navigation.goBack()), children: _jsx(BackIcon, { width: 24, height: 24, color: ICON_COLOR }) }), _jsx(TitleContainer, { children: showTitle && placeName ? (_jsx(TitleText, { numberOfLines: 1, children: placeName })) : null }), _jsxs(RightActions, { children: [_jsx(SccPressable, { elementName: "place_detail_v2_toggle_favorite_button", logParams: { isFavoritePlace: isFavorite }, onPress: onToggleFavorite, children: isFavorite ? (_jsx(BookmarkOnIcon, { width: 24, height: 24, color: color.brandColor })) : (_jsx(BookmarkIcon, { width: 24, height: 24, color: ICON_COLOR })) }), _jsx(SccPressable, { elementName: "place_detail_v2_share_button", onPress: onShare, children: _jsx(ShareIcon, { width: 24, height: 24, color: ICON_COLOR }) })] })] }));
}
const AppBarContainer = styled.View `
  flex-direction: row;
  align-items: center;
  padding-horizontal: 20px;
  padding-vertical: 10px;
  height: 50px;
  background-color: ${color.white};
`;
const TitleContainer = styled.View `
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  padding-horizontal: 8px;
`;
const TitleText = styled.Text `
  font-family: ${font.pretendardMedium};
  font-size: 18px;
  line-height: 26px;
  letter-spacing: -0.36px;
  color: #16181c;
`;
const RightActions = styled.View `
  flex-direction: row;
  align-items: center;
  gap: 12px;
`;
